import { Theme, useTheme } from "@mui/material";
import styled from "@emotion/styled";
import React from "react";

export type BaseInputType = "normal" | "area"
export interface BaseInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  children?: React.ReactNode;
  isDisabled?: boolean;
  inputType: BaseInputType;

  containerStyle?: React.CSSProperties;
  inputStyle?: React.CSSProperties;
  underlineStyle?: React.CSSProperties;
}

const BaseInputContainer = styled.div<{ type: BaseInputType, borderColor: string }>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  border: ${({ type, borderColor }) =>  type !== "normal" ? `1px solid ${borderColor}` : "none"};
  border-radius: ${({ type }) =>  type !== "normal" ? "1.5rem" : "none"};
  padding: ${({ type }) =>  type !== "normal" ? "1.375rem 1.5rem" : "none"};
`;

const BaseInputContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const InputText = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 8px 0;
  width: 100%;
  background: transparent;
`;

const UnderLineDivider = styled.div<{ theme: Theme }>`
  width: 100%;
  height: 2px;
  background-color: ${({ theme }) => theme.palette.primary.main};
`;

// ✅ 합성 컴포넌트 패턴 적용
const BaseInput = Object.assign(
  ({
    value,
    onChange,
    placeholder = "Enter text...",
    children,
    isDisabled = false,
    inputType = "normal",
    containerStyle,
    inputStyle,
    underlineStyle,
  }: BaseInputProps) => {
    const theme = useTheme();

    return (
      <BaseInputContainer
        type={inputType}
        borderColor={theme.palette.secondary.main}
        style={containerStyle}
      >
        {children && <div>{children}</div>}
        <BaseInputContent>
          <InputText
            disabled={isDisabled}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            style={inputStyle}
          />
          <UnderLineDivider theme={theme} style={underlineStyle} />
        </BaseInputContent>
      </BaseInputContainer>
    );
  },
  {
    LeftElement: ({ children }: { children?: React.ReactNode }) => <>{children}</>,
  }
);


export default BaseInput;
